import { Environment } from "./type";

const devConfig = {
    TELEMETRY_IN_DEBUG_MODE: true,
    TELEMETRY_IN_DEV_MODE: true,
    TELEMETRY_ENABLE: false,
}

const stagingConfig = {
    TELEMETRY_IN_DEBUG_MODE: true,
    TELEMETRY_IN_DEV_MODE: true,
    TELEMETRY_ENABLE: true,
}

const prodConfig = {
    TELEMETRY_IN_DEBUG_MODE: false,
    TELEMETRY_IN_DEV_MODE: false,
    TELEMETRY_ENABLE: true,
}

const configMap = {
    dev: devConfig,
    test: devConfig,
    playground: devConfig,
    development: devConfig,
    staging: stagingConfig,
    production: prodConfig,
}

const environment = (process.env.REACT_APP_ENV as Environment) || 'development';

const commonConfig = {
    REQUEST_TIMEOUT: 60000,
    ENVIRONMENT: environment,
    API_URL: process.env.REACT_APP_API_URL,
    METAMAP_CLIENT_ID: process.env.REACT_APP_METAMAP_CLIENT_ID,
    TELEMETRY_SERVICE_NAME: 'lae-web',
    TELEMETRY_BASE_URL: 'https://hermes-ingest.moniepointinc.com/v1',
}

const mappedConfig = configMap[environment];

export const config = { ...commonConfig, ...mappedConfig }

// local storage keys
export const STORAGE_KEYS = {
    AGREEMENT_REFERENCE: "lae.agreement.reference",
    AGREEMENT_REFERENCE_DETAILS: "lae.agreement.details",
    AGREEMENT_FORM: "lae.agreement.form"
};
